const audit = {
    title: 'Activity Audit',
    period: 'Period',
    totalEvents: 'Total Events',
    activeUsers: 'Active Users',
    totalAnomalies: 'Suspicious Actions (Total)',
    unresolvedAnomalies: 'Unresolved Suspicious Actions',
    eventsByCategory: 'Events by Category',
    recentEvents: 'Recent Events',
    categoryAll: 'Category: All',
    time: 'Time',
    action: 'Action',
    result: 'Result',
    category: 'Category',
    user: 'User',
    resource: 'Resource',
    durationMs: 'Duration (ms)',
    noMatchingEvents: 'No matching events',
    summaryFetchFailed: 'Failed to fetch summary: {{message}}',
    eventsFetchFailed: 'Failed to fetch events: {{message}}',
    csvExportFailed: 'CSV export failed: {{message}}',
    results: {
      all: 'All',
      success: 'success',
      failure: 'failure',
      error: 'error',
    },
  };

export default audit;
